export const linkRefresh = {
    created(){
        // document.documentElement.scrollTop=0
        window.scrollTo(0,0)
    }
}